import { useLocation } from 'react-router-dom';
import { ShareButtons } from './ShareButtons';

export default function ContentShareSlot() {
  const { pathname } = useLocation();

  if (!/^\/(kennisbank|blog|advies)\/[^/]+/.test(pathname)) return null;

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <ShareButtons url={'https://staycoolairco.nl' + pathname} />
    </div>
  );
}
